<template>

    <div class="login">
        <h3>Welcome back! Log in with your registered email and password</h3>
        <form @submit.prevent="submitForm">
            <p>
                <label class="email" for="email">Email:</label>
                <input id="email" v-model="email" />
            </p>
            <p>
                <label class="password" for="password">Password:</label>
                <input id="password" v-model="password" />
            </p>
            <button class="button">Login</button>          
        </form>
        <br>
        <router-link to="/register" class="sign" >Have no account yet? Register Here </router-link>
        <p style="color:green" > test account >> email:test@test.it / pwd:123456 </p>
    </div>

</template>

<script>
import { app } from "../main.js";

export default {
    data() {
        return {
            email: "",
            password: "",
        };
    },
    methods: {
        submitForm() {
            console.log(this.email + " " + this.password);
            const URL = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyAzMfGy3Evj07jg4X8M31OVD26Ykqv-SYk";
            fetch(URL, {
                method: "POST",
                body: JSON.stringify({
                    email: this.email,
                    password: this.password,
                    returnSecureToken: true,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                console.log(data);
                // we get things from Firebase ... (username, token, exp, ...)
                // if the authen failed, we will get property "error" 
                if (data.error != null) {
                    console.log("ERROR");
                    console.log(data.error);
                    alert(data.error.message);
                }
                else {
                    // if the user is authenticated, we will record this info
                    // into the global properties. Hence, we can access this ...(idToken)
                    // ...we need to append idToken to the URL to inform Firebase that
                    // "this is me" ... "let me access whatever requires auth"
                    // Recall: in the "Rules" we may have this
                    //      ".write" : "auth != null"
                    app.config.globalProperties.$displayName = this.email; 
                    app.config.globalProperties.$idToken = data.idToken;
                    app.config.globalProperties.$expiresIn = data.expiresIn;
                    app.config.globalProperties.$authenticated = true;
                    // app.config.globalProperties.$wallet = 0;


                    // send the user back to /survey
                    this.$router.replace("/market");
                }
                })
                .catch((error) => console.log(error));
        },
    },
};
</script>

<style scoped>
.login {
    background: skyblue;
    padding: 40px;
    /* margin: center; */
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}
.email {
    margin-right: 0px;
    padding-right: 50px;
    font-family: Arial, Helvetica, sans-serif;
}
.password {
    margin-right: 25px;
}

.button {
    background-color: white;
    border: 3p;
    border-color: #4caf50;
    color:#4caf50;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}

.button:hover {
    background-color:#4caf50;
    border: 3p;
    color:white;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}
.sign {
    text-decoration: underline;
    background: none;
    color: black;
}
</style>
